import {ApiConfig} from '@/directives/types';

const API_BASE_URL: string = process.env.VUE_APP_API_URL || '';
const SIGN_IN_URL: string = process.env.VUE_APP_SIGN_IN_URL || '';

const config: ApiConfig = {
  baseURL: API_BASE_URL,
  endpoints: {}
};

const urls = {
  signin: SIGN_IN_URL
};

export default config;
export {urls};
